import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import { Button, Dropdown } from "react-bootstrap";
import Select from "react-select";




import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";


import Pagination from "react-js-pagination";
import { DonerIsLoading, DonerListWithPaggination } from "../../../store/selectors/DonnerSelector";
import PageLoader from "../../layouts/PageLoader";
import { VolunteerInitialLoad, VolunteerPaggination } from "../../../store/thunk/VolunteerThunk";
import { VolunteerIsLoading, VolunteerListWithPaggination } from "../../../store/selectors/VolunteerSelector";
import { format } from "date-fns";
import { getRoles } from "../../../helper/BackendHelper";

const Volunteers = ({ volunteers, isLoading }) => {

   // console.log({ doners });
   const [searchQuary, setSearchQuary] = useState("");

   const dispatch = useDispatch();

   const [roleList, setRoleList] = useState([])
   const [roleOption, setRoleOption] = useState([])
   const [roleQuary, setRoleQuary] = useState()



   useEffect(() => {

      if (VolunteerInitialLoad) {
         dispatch(VolunteerInitialLoad());

      }

      getRoles().then((res) => {

         if (res?.status == "success") {
            setRoleList(res?.data)
         }

      })

   }, [])

   useEffect(() => {
      setRoleOption(roleList.map((role) => ({
         value: role.lable,
         label: role.lable,
      })))
   }, [roleList])

   useEffect(() => {

      dispatch(VolunteerPaggination({ q: searchQuary, pageNumber: 1, role: roleQuary ? roleQuary : "" }))

   }, [searchQuary, roleQuary])

   const clearFilter = () => {
      setSearchQuary("");
      setRoleQuary();
   }



   // console.log({ volunteers });


   return (
      <Fragment>
         <PageLoader isLoading={isLoading} >
            {/* <PageTitle activeMenu="Users List" motherMenu="Users" /> */}
            <div className="row">
               <div className="col-lg-12">
                  <div className="card">
                     <div className="card-body">
                        <div className="row">
                           <div className="col-lg-4">
                              <div className="input-group search-area">
                                 <input type="text"
                                    className={`form-control active`}
                                    placeholder="Search by Name"
                                    onChange={(e) => setSearchQuary(e.currentTarget.value)}
                                    value={searchQuary}
                                 />
                                 <span className="input-group-text" >
                                    <i className="flaticon-381-search-2"></i>
                                 </span>
                              </div>
                           </div>
                           <div className="col-lg-4">
                              <Select
                                 // defaultValue={selectedOption}
                                 onChange={(data) => setRoleQuary(roleList.find((item) => item?.lable == data.value)?.value)}
                                 options={roleOption}
                                 style={{
                                    lineHeight: "40px",
                                    color: "#7e7e7e",
                                    paddingLeft: " 15px",
                                 }}
                                 placeholder="Select Role"
                                 name='role'
                              />
                           </div>
                           <div className="col-lg-2">
                              <div className="input-group">

                                 <Button onClick={clearFilter}>Clear Filter</Button>
                              </div>
                           </div>

                        </div>
                        <br />
                        <div className="table-responsive">
                           <table className="table mb-0 table-striped">
                              <thead>
                                 <tr>

                                    <th>Name</th>
                                    <th>Email ID</th>
                                    <th>Phone Number</th>
                                    <th>WhatsApp Number</th>
                                    <th>Role</th>

                                    <th>Registered on</th>
                                    <th></th>
                                 </tr>
                              </thead>
                              <tbody id="Volunteers">

                                 {
                                    volunteers?.data?.map((volunteer, index) => (
                                       <tr className="btn-reveal-trigger">

                                          <td className="py-3">
                                             <Link to={`/user-details/${volunteer?.id}`}>
                                                <div className="media d-flex align-items-center">

                                                   <div className="media-body">
                                                      <h5 className="mb-0 fs--1">
                                                         {volunteer?.name}
                                                      </h5>
                                                   </div>
                                                </div>
                                             </Link>
                                          </td>
                                          <td className="py-2">
                                             <a href={`mailto:${volunteer?.email}`}>
                                                {volunteer?.email}

                                             </a>
                                          </td>
                                          <td className="py-2">

                                             <a href={`tel:${volunteer?.phone}`}>{volunteer?.phone}
                                             </a>
                                          </td>
                                          <td className="py-2">

                                             <a href={`tel:${volunteer?.phone}`}>{volunteer?.phone}
                                             </a>
                                          </td>
                                          <td className="py-2 ">
                                             {volunteer?.role?.name}
                                          </td>

                                          <td className="py-2">
                                             {format(new Date(volunteer?.created_at), "dd-MM-yyyy")}
                                          </td>
                                          <td className="py-2 text-right">
                                             <Dropdown>
                                                <Dropdown.Toggle variant="" className="btn btn-primary tp-btn-light sharp i-false">
                                                   <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                         <rect x="0" y="0" width="24" height="24"></rect>
                                                         <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                                                         <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                                                         <circle fill="#000000" cx="19" cy="12" r="2"></circle>
                                                      </g>
                                                   </svg>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                   <Link to={`/user-details/${volunteer?.id}`}>
                                                      <Dropdown.Item href={`/user-details/${volunteer?.id}`} >View</Dropdown.Item>
                                                   </Link>
                                                   <Link to={`/user-edit/${volunteer?.id}`}>
                                                      <Dropdown.Item href={`/user-edit/${volunteer?.id}`} >Edit</Dropdown.Item>
                                                   </Link>
                                                   {/* <Dropdown.Item href="#" className="text-danger">
                                                      Delete
                                                   </Dropdown.Item> */}
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </td>
                                       </tr>
                                    ))
                                 }



                              </tbody>
                           </table>
                        </div>
                        <br />
                        <div>
                           <Pagination
                              activePage={volunteers?.current_page ? volunteers?.current_page : 0}
                              itemsCountPerPage={volunteers?.per_page ? volunteers?.per_page : 0}
                              totalItemsCount={volunteers?.total ? volunteers?.total : 0}
                              onChange={(pageNumber) => {

                                 dispatch(VolunteerPaggination({ q: searchQuary, pageNumber, role: roleQuary ? roleQuary : "" }))
                              }}
                              pageRangeDisplayed={8}
                              itemClass="page-item"
                              linkClass="page-link"
                              firstPageText="First Page"
                              lastPageText="Last Page"
                           />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </PageLoader>

      </Fragment>
   );
};


const mapStateToProps = (state) => {
   return {
      volunteers: VolunteerListWithPaggination(state),
      isLoading: VolunteerIsLoading(state)
   };
};

export default connect(mapStateToProps)(Volunteers);


